"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dimensions = {
    BRAND: {
        SUB_DIS: 'sub-dis',
        BMW_DIS: 'bmw-dis',
    },
    COUNTRY: {
        AU: 'au',
    },
};
